<!-- Slide-in panel on the right: instrument details. -->
<script lang="ts">
  import { closeDrawer } from "../lib/actions";
  import { app } from "../lib/state.svelte";
  import Instrument from "../views/Instrument.svelte";
</script>

{#if app.drawerKey && app.model}
  <!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_static_element_interactions -->
  <div id="drawer" class="drawer" onclick={(e) => { if (e.target === e.currentTarget) closeDrawer(); }}>
    <div class="drawer-panel">
      <button class="drawer-close" aria-label="Zamknij" onclick={closeDrawer}>×</button>
      <div id="drawerBody">
        {#key app.drawerKey}<Instrument key={app.drawerKey} />{/key}
      </div>
    </div>
  </div>
{/if}
